import { render } from "./TicketDetailDrawer.vue?vue&type=template&id=484b15d7&scoped=true"
import script from "./TicketDetailDrawer.vue?vue&type=script&lang=js"
export * from "./TicketDetailDrawer.vue?vue&type=script&lang=js"

import "./TicketDetailDrawer.vue?vue&type=style&index=0&id=484b15d7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484b15d7"]])

export default __exports__